// `height` sets each logo's own display height (Tailwind h-* class); omit to fall back to the default in TestimonialsSection.
export const clientLogos = [
    { name: 'Jeeno', src: '/images/clients/Jeeno.webp', height: 'h-8' },
    { name: 'Learning', src: '/images/clients/learning.webp', height: 'h-8' },
    { name: 'Capex', src: '/images/clients/capex-logo.webp', height: 'h-8' },
    { name: 'MyRE', src: '/images/clients/myaree.webp', height: 'h-6' },
    { name: 'Progress', src: '/images/clients/progress.webp', height: 'h-6' },
    { name: 'OK-Saftey', src: '/images/portfolio/ok-safety/OK-Saftey-logo.webp', height: 'h-8' },
    { name: 'Crowder Supply', src: '/images/clients/crowder-supply.webp', height: 'h-8' },
    { name: 'Gleam', src: '/images/clients/gleam.webp', height: 'h-8' },
    { name: 'Zero Defects', src: '/images/clients/zdi.webp', height: 'h-8' },
    { name: 'Adam', src: '/images/clients/adam.webp', height: 'h-8' },
    { name: 'nao medical', src: '/images/clients/nao-medical.webp', height: 'h-8' },
    { name: 'JA Willow', src: '/images/clients/ja-willow.webp', height: 'h-8' },
    { name: 'Find a Pet', src: '/images/clients/find-pet.webp', height: 'h-8' },
    { name: 'Mavs Shop', src: '/images/clients/mavs-shop.webp', height: 'h-6' },
    { name: 'Earth Savers', src: '/images/clients/earth-savers.webp', height: 'h-8' },
    { name: 'Lux View', src: '/images/clients/lux-view.webp', height: 'h-8' },
    { name: 'Referred Roofing', src: '/images/clients/referred-roofing.webp', height: 'h-8' },
    { name: 'Apogee Event Productions', src: '/images/clients/apogee.webp', height: 'h-8' },
];